import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { Settings } from "lucide-react";

interface HeaderProps {
  isRunning: boolean;
  startTime?: string;
  ipAddress?: string;
  queueCount: number;
  timezone: "local" | "utc";
  onTimezoneChange: (tz: "local" | "utc") => void;
  onOpenSettings?: () => void;
}

export function Header({
  isRunning,
  startTime,
  ipAddress,
  queueCount,
  timezone,
  onTimezoneChange,
  onOpenSettings,
}: HeaderProps) {
  return (
    <section className="cyber-card border border-border/50 bg-background/40 backdrop-blur-sm p-4 sm:p-6">
      <div className="flex items-start justify-between gap-4 flex-wrap">
        <div>
          <h1 className="text-2xl font-mono font-bold">Live Scan</h1>
          <p className="text-sm text-muted-foreground">
            Trigger scans, watch live logs, and generate reports.
          </p>
        </div>

        <div className="flex items-center gap-3 flex-wrap justify-end">
          {isRunning && (
            <div className="flex items-center gap-2 text-sm">
              <span className="flex h-2 w-2 rounded-full bg-[hsl(var(--ss-success))] animate-pulse" />
              <span className="text-muted-foreground">
                Running{startTime ? ` • started ${startTime}` : ""}
              </span>
              {ipAddress && (
                <>
                  <span className="text-muted-foreground">|</span>
                  <span className="text-muted-foreground">IP: {ipAddress}</span>
                </>
              )}
            </div>
          )}

          <Badge variant="info">
            Queue ({queueCount})
          </Badge>

          <div className="flex items-center gap-2">
            <span className="text-sm text-muted-foreground">TZ</span>
            <Select value={timezone} onValueChange={(v) => onTimezoneChange(v as "local" | "utc")}>
              <SelectTrigger className="w-24 bg-background/50 border-border/50">
                <SelectValue />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="local">Local</SelectItem>
                <SelectItem value="utc">UTC</SelectItem>
              </SelectContent>
            </Select>
          </div>

          <Button variant="outline" size="sm" onClick={onOpenSettings} disabled={!onOpenSettings}>
            <Settings className="mr-2 h-4 w-4" />
            Settings
          </Button>
        </div>
      </div>
    </section>
  );
}
